function getRectangleTopLeft(left: number, top: number, width: number, height: number, angle: number) {
  // assuming transform origin as center;
  const originX = left + width / 2;
  const originY = top + height / 2;

  // Converting anticlockwise angle to clockwise angle
  const viewRotation = -1 * angle;

  // convert degrees to radians
  const rotationInRadians = viewRotation * (Math.PI / 180);
  const rotationCos = Math.cos(rotationInRadians);
  const rotationSin = Math.sin(rotationInRadians);

  // TODO - Find the trignometry formula for get left and top at any angle
  switch (angle) {
    case 90:
      {
        left = left + width;
        break;
      }
    case 180:
      {
        left = left + width;
        top = top + height;
        break;
      }
    case 270:
      {
        top = top + height;
        break;
      }
  }
  const newX = (left - originX) * rotationCos - (top - originY) * rotationSin + originX;
  const newY = (left - originX) * rotationSin + (top - originY) * rotationCos + originY;
  return {
    left: newX,
    top: newY
  };
}
export default function getMousePos(event: {
  clientX: number;
  clientY: number;
}, containerBoundingBox: ClientRect | undefined | null, scale: number, rotation: number): [number, number] {
  let left = containerBoundingBox?.left ?? 0;
  let top = containerBoundingBox?.top ?? 0;
  const width = containerBoundingBox?.width ?? 0;
  const height = containerBoundingBox?.height ?? 0;

  // TODO - get originX, originY based on pane and zoom center
  // assuming transform origin as center;
  const originX = left + width / 2;
  const originY = top + height / 2;
  let clientX = event.clientX;
  let clientY = event.clientY;
  if (rotation > 0 && rotation < 360) {
    // Converting anticlockwise angle to clockwise angle
    const viewRotation = -1 * rotation;

    // convert degrees to radians
    const rotationInRadians = viewRotation * (Math.PI / 180);
    const rotationCos = Math.cos(rotationInRadians);
    const rotationSin = Math.sin(rotationInRadians);

    // reference for formula - https://danceswithcode.net/engineeringnotes/rotations_in_2d/rotations_in_2d.html
    const newClientX = (clientX - originX) * rotationCos - (clientY - originY) * rotationSin + originX;

    // had to change how we calculate Y coordinate as Y axis is inversed in browser
    const newClientY = (clientY - originY) * rotationCos + (clientX - originX) * rotationSin + originY;
    clientX = newClientX;
    clientY = newClientY;

    // get the original top left coordinates when rotation was 0deg
    const {
      left: newLeft,
      top: newTop
    } = getRectangleTopLeft(left, top, width, height, rotation);
    left = newLeft;
    top = newTop;
  }
  return [(clientX - left) / scale, (clientY - top) / scale];
}